const SET_MAP_DATA = 'Planner/mapData/SET_MAP_DATA'
const START_MAP_LOADING = 'Planner/mapData/START_MAP_LOADING'
const FINISH_MAP_LOADING = 'Planner/mapData/FINISH_MAP_LOADING'
const SET_MAP_ERROR = 'Planner/mapData/SET_MAP_ERROR'

const initialState = {
  data: {
    projects: [],
    subcontractors: []
  },
  loading: false,
  error: null
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MAP_DATA:
      const payload = action.payload || {}
      // Deep clone projects and subcontractors to prevent reference mutation issues
      return {
        ...state,
        data: {
          ...payload,
          projects: (payload.projects || []).map(p => ({ ...p, scheduled_subcontractors: [...(p.scheduled_subcontractors || [])] })),
          subcontractors: (payload.subcontractors || []).map(s => ({ ...s, scheduled_projects: [...(s.scheduled_projects || [])] })),
        },
        error: null
      }
    case START_MAP_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      }
    case FINISH_MAP_LOADING:
      return {
        ...state,
        loading: false
      }
    case SET_MAP_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export const setMapData = (data) => ({
  type: SET_MAP_DATA,
  payload: data
})

export const startMapLoading = () => ({
  type: START_MAP_LOADING
})

export const finishMapLoading = () => ({
  type: FINISH_MAP_LOADING
})

export const setMapError = (error) => ({
  type: SET_MAP_ERROR,
  payload: error
})
